// การ์ดเล็ก (bubble micro) แจ้งรางวัลจากเกมวงล้อ/รูเล็ต โทนดำทอง ส่งผ่าน liff.sendMessages
// preview: broadcast-assets/flex-micro-preview.html
const COIN_IMG = "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fcoin.png?alt=media";
const CHIP_IMG = "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fchips.png?alt=media";
const REWARD_URI = "https://liff.line.me/2006378234-72e9GVNa/reward";

const GAMES = {
  spin: { tag: "🎡 วงล้อ", image: COIN_IMG, unit: "Coins", bigWin: 30 },
  roulet: { tag: "🎯 รูเล็ต", image: CHIP_IMG, unit: "เครดิต", bigWin: 100 }
};

function formatNumber(n) {
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// game: 'spin' | 'roulet', amount: number (0 = ไม่ได้รางวัล)
function buildRewardFlex(game, amount) {
  const g = GAMES[game] || GAMES.spin;
  const value = Number(amount) || 0;
  const zero = value <= 0;
  const big = !zero && value >= g.bigWin;
  const border = big ? "#FF8A80" : "#FFD45A";
  const tagBg = big ? "#FF5C52" : "#F2B71D";
  const tagFg = big ? "#3A0000" : "#1A1200";
  const tagText = big ? `${g.tag} · รางวัลใหญ่` : g.tag;
  const title = zero ? "ยังไม่ได้รอบนี้" : "ยินดีด้วยค่ะ!";
  const sub = zero ? "พรุ่งนี้มาลุ้นใหม่นะคะ" : "แตะเพื่อดูรางวัลทั้งหมด";
  const altText = zero
    ? `${g.tag} รอบนี้ยังไม่ได้รางวัล พรุ่งนี้มาลุ้นใหม่นะคะ`
    : `ปังปุรีเย่!! ${g.tag} ได้รับ +${formatNumber(value)} ${g.unit}`;

  return {
    type: "flex",
    altText,
    contents: {
      type: "bubble",
      size: "micro",
      styles: { body: { backgroundColor: "#0B0B0B" }, footer: { backgroundColor: "#0B0B0B", separator: false } },
      body: {
        type: "box",
        layout: "vertical",
        paddingAll: "10px",
        borderWidth: "1.5px",
        borderColor: border,
        cornerRadius: "14px",
        background: { type: "linearGradient", angle: "160deg", startColor: "#1A1A1A", centerColor: "#000000", endColor: "#03140A", centerPosition: "55%" },
        action: { type: "uri", label: "reward", uri: REWARD_URI },
        contents: [
          {
            type: "box",
            layout: "horizontal",
            justifyContent: "center",
            contents: [
              {
                type: "box",
                layout: "vertical",
                flex: 0,
                backgroundColor: tagBg,
                cornerRadius: "20px",
                paddingTop: "1px",
                paddingBottom: "1px",
                paddingStart: "8px",
                paddingEnd: "8px",
                contents: [{ type: "text", text: tagText, size: "xxs", weight: "bold", color: tagFg, align: "center" }]
              }
            ]
          },
          { type: "text", text: title, size: "md", weight: "bold", color: "#FFD45A", align: "center", margin: "sm" },
          { type: "image", url: g.image, size: "60px", aspectMode: "fit", align: "center", margin: "md" },
          { type: "text", text: zero ? "0" : `+${formatNumber(value)}`, size: "3xl", weight: "bold", color: "#FFD45A", align: "center", margin: "sm" },
          { type: "text", text: g.unit, size: "xs", weight: "bold", color: "#FFE9A8", align: "center" },
          { type: "text", text: sub, size: "xxs", color: "#7A7A7A", align: "center", margin: "md", wrap: true }
        ]
      },
      footer: {
        type: "box",
        layout: "vertical",
        paddingAll: "0px",
        height: "2px",
        background: { type: "linearGradient", angle: "90deg", startColor: "#0B0B0B", centerColor: "#FFD45A", endColor: "#0B0B0B" },
        contents: [{ type: "filler" }]
      }
    }
  };
}

module.exports = { buildRewardFlex, GAMES };
